/* Keep the floating social section outside transformed theme containers. */
(() => {
  const mountSocialFloat = (root = document) => {
    const floats = root.matches?.('[data-custom-social-float]')
      ? [root]
      : root.querySelectorAll?.('[data-custom-social-float]') || [];

    floats.forEach((float) => {
      const sectionWrapper = float.closest('.shopify-section');
      if (sectionWrapper && sectionWrapper.parentElement !== document.body) {
        document.body.appendChild(sectionWrapper);
      }
    });
  };

  mountSocialFloat();

  if (!window.stelliesSocialFloatEditorListener) {
    window.stelliesSocialFloatEditorListener = true;
    document.addEventListener('shopify:section:load', (event) => mountSocialFloat(event.target));
  }
})();
